import { Box, MetricComponent, Title, Tooltip } from 'components'
import { GrowthBar } from 'components/GrowthBar'
import { Colors } from 'constants/colors'
import styled from 'styled-components'
import { formatBigNumber, getSpacing } from 'utils'
import { ISummaryProps } from '.'

const VerticalLine = styled.div`
  border-left: solid 1px ${Colors.GRAY_5};
  height: 100%;
`
export const SummaryDesktop = ({
  positionTooltip,
  borrowTooltip,
  totalDeposited,
  interestRate,
  totalBorrowed,
  borrowUsage,
  usageTextColor,
  coreCapsules,
}: ISummaryProps) => {
  return (
    <Box
      flexDirection="column"
      justifyContent="space-between"
      padding={getSpacing('m')}
      backgroundColor={'BG_ELEVATED'}
      borderRadius="14px"
      height={'100%'}
    >
      <Box flexDirection="row" alignItems="center">
        <Title tag="h2" size="m" weight="semi-bold">
          Position Summary
        </Title>
        {positionTooltip && (
          <Box paddingLeft={getSpacing('xs')}>
            <Tooltip content={positionTooltip} />
          </Box>
        )}
      </Box>

      <Box flexDirection="row" justifyContent="space-between" width="80%">
        <MetricComponent
          title="Borrow usage"
          value={formatBigNumber(borrowUsage.mul(100), 2) + '%'}
          tooltip={borrowTooltip}
          valueColor={usageTextColor}
        />

        <Box flexDirection="column" paddingRight={getSpacing('s')}>
          <VerticalLine />
        </Box>

        <MetricComponent title="Borrowed" value={'$' + formatBigNumber(totalBorrowed)} />
        <MetricComponent title="Deposited" value={'$' + formatBigNumber(totalDeposited)} />
        <MetricComponent title="Interest" value={formatBigNumber(interestRate.mul(100)) + '%'} />
      </Box>

      <GrowthBar borrowUsage={borrowUsage} coreCapsules={coreCapsules} />
    </Box>
  )
}
